import { render, staticRenderFns } from "./claim-log-component.vue?vue&type=template&id=56cec45f&"
import script from "./claim-log-component.vue?vue&type=script&lang=ts&"
export * from "./claim-log-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports